module.exports = __webpack_public_path__ + "static/media/rounded-rect-secondary.1f46752b.png";